import {DialogConfigInterface} from '@shared/model';

export class DialogHelper {
  public static getHideDialogConfig(index: string, title?: string, top: string = '0px', left: string = '0px'): DialogConfigInterface {
    return {
      id: index,
      show: false,
      isFirstPlan: false,
      title
    };
  }
}
